var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"acheteur-status-label",style:({backgroundColor: _vm.background, color: _vm.color, border: '1px solid ' + _vm.color})},[_vm._v(" "+_vm._s(_vm.acheteur.typeLabel)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }